import ListItem from "./ListItem";

const List = ({ tasks, setTasks }) => {
  return (
    <div className="task-list">
      {tasks.map((task, i) => (
        <ListItem task={task} setTasks={setTasks} key={i} />
      ))}
    </div>
  );
};

export default List;
